import boardAi2Icon from "@/assets/img/icon_board-ai2.webp";
import boardAimgIcon from "@/assets/img/icon_board-aimg.webp";
import boardDarkIcon from "@/assets/img/icon_board-dark.webp";
import boardGoreIcon from "@/assets/img/icon_board-gore.webp";
import boardLongIcon from "@/assets/img/icon_board-long.webp";

export type BoardCardCopy = Readonly<{
  name: string;
  description: string;
  /** ビルド後のasset URL。vite.config.tsでinline対象から外してあるため、
   *  ここに入るのはパス文字列だけで、実体は<img>描画時に取得される。 */
  iconSrc: string;
}>;

/**
 * 総合カタログ設定カードの見出し・説明文・アイコン。
 *
 * ラインナップ定義(`src/config/mixLineup.ts`)へは置かない。あちらは
 * Worker と bootstrap が読む初期グラフ側で、設定画面と初回パネルでしか
 * 使わない文言と画像を常駐させたくないため。
 * ラインナップに無いslug(dev用テスト板など)はundefinedになり、
 * 呼び出し側が絵文字とslug表示へ縮退する。
 */
export const BOARD_CARDS: Readonly<Record<string, BoardCardCopy>> =
  Object.freeze({
    aimg: Object.freeze({
      name: "二次元裏",
      description: "総合雑談。基本的にはこちらへ。",
      iconSrc: boardAimgIcon,
    }),
    ai2: Object.freeze({
      name: "二次元AI裏",
      description:
        "R-18のAI生成画像特化板。画像数の多い連番作品はこちらを推奨。",
      iconSrc: boardAi2Icon,
    }),
    gore: Object.freeze({
      name: "二次元グロ裏",
      description:
        "他では禁止されている、R-18G、大スカを解禁した板。気を付けてね！",
      iconSrc: boardGoreIcon,
    }),
    dark: Object.freeze({
      name: "ダーク",
      description: "発散しよう",
      iconSrc: boardDarkIcon,
    }),
    long: Object.freeze({
      name: "まったり",
      description:
        "スレ立ては1日1回、返信は5分に1回まで。急がずまったり、ひとつの話題を長期間楽しめる板です。",
      iconSrc: boardLongIcon,
    }),
  });
